import { Injectable } from '@angular/core';
import { Http, Headers, Response, URLSearchParams } from '@angular/http';
import { Observable } from 'rxjs';
import 'rxjs/add/operator/map';
import { Subject } from 'rxjs/Subject';
import { environment } from './../../environments/environment';
import { ErrorService } from './error.service';
import { CarrierService } from './carrier.service';
// import { JwtHelper } from 'angular2-jwt';
import { JwtHelperService } from '@auth0/angular-jwt'
import { AuthHelper } from '../shared/auth-helper';

@Injectable()
export class AuthenticationService {
    public token: string;
    jwtHelper: JwtHelperService = new JwtHelperService();

    private url = environment.api_url + environment.version + 'account/';

    constructor(
        private http: Http,
        private errorService: ErrorService,
        private carrierService: CarrierService
        ) {
      this.token = AuthHelper.GetRawToken();
     }

    login(username: string, password: string): Observable<boolean> {
        return this.http.post(this.url + 'login', { 'username': username, 'password': password, 'source': 'web' })
            .map((response: Response) => {
                // login successful if there's a jwt token in the response
                const token = response.json() && response.json().access_token;
                const expires_in = response.json() && response.json().expires_in;
                let timer = Date.now();
                if (expires_in) {
                    timer += expires_in;
                }
                if (token) {
                    // set token property
                    this.token = token;

                    // store username and jwt token in local storage to keep user logged in between page refreshes
                    // carrierId initially 0 until we get it back below.  have to store this before we can make the call below
                    localStorage.setItem('currentUser', JSON.stringify({
                        username: username,
                        id: response.json() && response.json().id,
                        auth_token: token,
                        fullName: response.json() && response.json().full_name,
                        role: response.json() && response.json().role_name,
                        timer: timer
                    }));

                    // return true to indicate successful login
                    return true;
                } else {
                    // return false to indicate failed login
                    return false;
                }
            });
    }

    tokenLogin(token: string) {
        localStorage.setItem('currentUser', JSON.stringify({
            auth_token: token
        }));

        return this.http.get(this.url + 'checktoken')
            .map((response: Response) => {
                // login successful if there's a jwt token in the response
                const expires_in = response.json() && response.json().expires_in;
                const user_name = response.json() && response.json().user_name;
                let timer = Date.now();
                if (expires_in) {
                    timer += expires_in;
                }
                // set token property
                this.token = token;

                // store username and jwt token in local storage to keep user logged in between page refreshes
                // carrierId initially 0 until we get it back below.  have to store this before we can make the call below
                localStorage.setItem('currentUser', JSON.stringify({
                    username: user_name,
                    id: response.json() && response.json().id,
                    auth_token: token,
                    fullName: response.json() && response.json().full_name,
                    role: response.json() && response.json().role_name,
                    timer: timer
                }));

                // return true to indicate successful login
                return true;
            });
    }

    logout() {
        // remove user from local storage to log user out
        this.token = null;
        localStorage.removeItem('currentUser');
    }
}
